/* eslint-disable react/require-default-props */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Select, Spin } from 'antd';
import axios from 'axios';

import { request } from '../helpers/requests';
import { stringArraysEqual } from '../helpers/helpers';

export default function CostcodeSelector({
  onlyActive = true,
  divisionIds,
  projectIds,
  onlyGlobal,
  categoryIds,
  value,
  onChange,
  ...restProps
}) {
  const [lastConfig, setLastConfig] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const optionsValues = useMemo(() => new Set(options.map((option) => option.value)), [options]);

  const getOptions = async () => {
    if (loading) return;
    if (
      lastConfig?.onlyActive === onlyActive
      && stringArraysEqual(lastConfig?.divisionIds, divisionIds)
      && stringArraysEqual(lastConfig?.projectIds, projectIds)
      && lastConfig?.onlyGlobal === onlyGlobal
      && stringArraysEqual(lastConfig?.categoryIds, categoryIds)
    ) return;

    const hasValidDivisions = divisionIds.filter(Boolean).length > 0;

    if (!hasValidDivisions) {
      setLoading(false);
      setOptions([]);
      return;
    }

    setLoading(true);
    const res = await request({
      call: axios.post('/costcodes/options', {
        onlyActive,
        divisionIds: divisionIds.filter(Boolean),
        projectIds,
        onlyGlobal,
        categoryIds,
      }),
      errMsg: 'Could not get costcode options',
      hideSuccessToast: true,
    });
    setLoading(false);
    if (res?.data) {
      setOptions(res.data);
      setLastConfig({
        onlyActive,
        divisionIds,
        projectIds,
        onlyGlobal,
        categoryIds,
      });
    }
  };

  const getOptionById = async (id) => {
    const res = await request({
      call: axios.get(`/costcodes/option/${id}`),
      errMsg: 'Could not get costcode option',
      hideSuccessToast: true,
    });
    if (res?.data) {
      setOptions(options.concat(res.data));
    }
  };

  const realValue = optionsValues.has(value) ? value : null;

  if (value?.length && !optionsValues.has(value)) {
    getOptionById(value);
  }

  return (
    <Spin size="small" spinning={loading}>
      <Select
        value={realValue}
        onChange={loading ? undefined : onChange}
        options={options}
        placeholder="Select a Cost Code"
        allowClear
        showSearch
        optionFilterProp="label"
        onDropdownVisibleChange={(open) => {
          if (open) getOptions();
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...restProps}
      />
    </Spin>
  );
}

CostcodeSelector.propTypes = {
  onlyActive: PropTypes.bool,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.arrayOf(PropTypes.string),
  projectIds: PropTypes.arrayOf(PropTypes.string),
  phaseIds: PropTypes.arrayOf(PropTypes.string),
  onlyGlobal: PropTypes.bool,
  onlyUnphased: PropTypes.bool,
  categoryIds: PropTypes.arrayOf(PropTypes.string),
  canClockIn: PropTypes.bool,
  onChange: PropTypes.func,
};
